const Type = 'text-replacements';
const TextReplacementPlugin = options => {
  const replacementsRegExp = new RegExp(Object.keys(options.replacements).map(escapeRegex).join('|'), 'g');
  return {
    type: Type,
    serialize: {
      leaf(props) {
        return replaceTextMatches(props.children, replacementsRegExp, options.replacements);
      }
    }
  };
};
function escapeRegex(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function replaceTextMatches(input, replacementsRegExp, replacements) {
  return input.replace(replacementsRegExp, match => {
    if (match in replacements) {
      return replacements[match];
    }
    return match;
  });
}

export { TextReplacementPlugin, Type };
